(() => {
  const sliders = new Map();

  const mountSlider = (panel) => {
    const sliderRoot = panel.querySelector('[data-collection-slider]');
    if (!sliderRoot || sliders.has(sliderRoot)) return;

    const swiperElement = sliderRoot.querySelector('.collection-tabs__swiper');
    if (!swiperElement || !window.Swiper) return;

    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;
    const section = panel.closest('[data-collection-tabs]');
    const gapValue = getComputedStyle(section).getPropertyValue('--collection-tabs-gap');
    const gap = Number.parseInt(gapValue, 10) || 24;
    const slidesDesktop = Number.parseFloat(section.dataset.slidesDesktop) || 4;
    const slidesTablet = Number.parseFloat(section.dataset.slidesTablet) || 2;
    const slidesMobile = Number.parseFloat(section.dataset.slidesMobile) || 1.8;

    const swiper = new Swiper(swiperElement, {
      slidesPerView: slidesMobile,
      spaceBetween: 20,
      slidesOffsetAfter: slidesMobile % 1 === 0 ? 0 : 20,
      watchOverflow: true,
      navigation: {
        prevEl: sliderRoot.querySelector('[data-slider-prev]'),
        nextEl: sliderRoot.querySelector('[data-slider-next]'),
      },
      pagination: {
        el: sliderRoot.querySelector('.collection-tabs__pagination'),
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
          slidesOffsetAfter: 20,
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: gap,
          slidesOffsetAfter: 0,
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
      },
      on: {
        init(swiperInstance) {
          if (slideCount <= swiperInstance.params.slidesPerView) {
            swiperInstance.pagination.el.style.display = 'none';
          }
        },
      },
    });

    sliders.set(sliderRoot, swiper);
  };

  const destroySlider = (sliderRoot) => {
    const swiper = sliders.get(sliderRoot);
    if (!swiper) return;

    swiper.destroy(true, true);
    sliders.delete(sliderRoot);
  };

  const activatePanel = (section, panelId) => {
    section.querySelectorAll('[data-collection-tab]').forEach((tab) => {
      const isActive = tab.dataset.target === panelId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('[data-collection-panel]').forEach((panel) => {
      const isActive = panel.dataset.panelId === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        mountSlider(panel);
        const sliderRoot = panel.querySelector('[data-collection-slider]');
        const swiper = sliders.get(sliderRoot);
        if (swiper) swiper.update();
      }
    });
  };

  const initSection = (section) => {
    if (section.dataset.collectionTabsInit === 'true') return;
    section.dataset.collectionTabsInit = 'true';

    section.querySelectorAll('[data-collection-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activatePanel(section, tab.dataset.target);
      });
    });

    const activePanel = section.querySelector('[data-collection-panel].is-active');
    if (activePanel) mountSlider(activePanel);
  };

  const mountAll = (scope = document) => {
    scope.querySelectorAll('[data-collection-tabs]').forEach(initSection);
  };

  const destroyAll = (scope = document) => {
    scope.querySelectorAll('[data-collection-slider]').forEach(destroySlider);
    scope.querySelectorAll('[data-collection-tabs]').forEach((section) => {
      delete section.dataset.collectionTabsInit;
    });
  };

  const init = () => {
    if (window.Swiper) {
      mountAll();
      return;
    }

    window.addEventListener('load', () => mountAll(), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      sliders.forEach((swiper) => {
        if (swiper) swiper.update();
      });
      mountAll();
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    mountAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });
})();
